import { Dropdown } from 'primereact/dropdown';
import { Tooltip } from 'primereact/tooltip';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { LabelValue } from '../../../../../../../types/options';
import FieldWithErrors from '../../../../../../Forms/ReactHookForm/FieldWithErrors';
import { Headquarters } from '../../CreateEditDialog.functions';

type Props = {
  priceListOptions: LabelValue<number>[];
  isPriceListsLoading: boolean;
  isHeadquarter: any;
  headquarterData: any; // WithData<Headquarters[]>;
  isHeadquarterDataLoading: boolean;
};

function isDisabled(
  values: any,
  isHeadquarter: boolean,
  headquarterData: Headquarters,
  isHeadquarterDataLoading: boolean,
  isPriceListsLoading: boolean
) {
  if (isPriceListsLoading || isHeadquarterDataLoading) {
    return true;
  } else {
    if (isHeadquarter) {
      return false;
    } else {
      if (values.pravno_lice) {
        return (
          values.direkcija_id !== null &&
          headquarterData?.same_price_list_for_subsidiaries === 1
        );
      } else {
        return false;
      }
    }
  }
}

function PriceListFieldRecipient({
  priceListOptions,
  isPriceListsLoading,
  isHeadquarter,
  headquarterData,
  isHeadquarterDataLoading,
}: Props) {
  const { t } = useTranslation();

  const { getValues } = useFormContext();
  const isFieldDisabled = isDisabled(
    getValues(),
    isHeadquarter,
    headquarterData,
    isHeadquarterDataLoading,
    isPriceListsLoading
  );

  return (
    <>
      <Tooltip
        target=".pricelistrecipient-tooltip"
        position="left"
        style={!isFieldDisabled ? { display: 'none' } : {}}
      />

      <div
        className="pricelistrecipient-tooltip"
        data-pr-tooltip={
          !isPriceListsLoading && !isHeadquarterDataLoading && isFieldDisabled
            ? t(
                'The headquarter is using one price list for all of its subsidiaries.'
              )
            : ''
        }
      >
        <FieldWithErrors
          name="recipient_pricelist_id"
          label={t('Force price list for recipient')}
        >
          <Controller
            name="recipient_pricelist_id"
            render={({ field }) => (
              <Dropdown
                id="recipient_pricelist_id"
                name="recipient_pricelist_id"
                options={priceListOptions}
                value={field.value}
                onChange={field.onChange}
                disabled={isFieldDisabled}
                className="data-cy-price_list_recipient"
              />
            )}
          />
        </FieldWithErrors>
      </div>
    </>
  );
}

export default PriceListFieldRecipient;
